var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#838383",
    d: "M23.22 2.78A9.5 9.5 0 1 1 9.8 16.2 9.5 9.5 0 0 1 23.22 2.78zm.66 6.71a7.37 7.37 0 1 0-14.74 0 7.37 7.37 0 0 0 14.74 0zM2.81 24.7a1.06 1.06 0 0 1-1.5-1.5l5.3-5.3a1.06 1.06 0 0 1 1.5 1.5l-5.3 5.3zM20.56 9.13a1.06 1.06 0 0 1 2.11-.19 6.05 6.05 0 0 1-.04 1.43 1.06 1.06 0 1 1-2.1-.3 4.4 4.4 0 0 0 .03-.95zm-1.17 3.24a1.06 1.06 0 0 1 1.5 1.5 6.19 6.19 0 0 1-8.76 0 1.06 1.06 0 0 1 1.5-1.5 4.07 4.07 0 0 0 5.76 0z",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.d394a32785a4bf5835f9d0a3618258f3.svg";
export { ForwardRef as ReactComponent };